import { BaseItem, BaseContent } from 'components/Widget/Menu/style';
import styled from 'styled-components';
import { unthemed, layout } from 'tokens';
interface BaseProps {
	panelsVisible: boolean;
}
const footerHeight = 20;

export const Base = styled.div<BaseProps>`
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	height: 100%;
	display: grid;
	grid-template-rows: ${layout.inspectorNavbarHeight}px 1fr ${footerHeight}px;
	grid-template-columns: ${(props) => (props.panelsVisible ? 'auto 1fr' : '1fr')};
	grid-template-areas: ${(props) =>
		props.panelsVisible
			? `"navbar navbar"
			   "left-panel prototype"
			   "left-panel footer"`
			: `"navbar"
			   "prototype"
			   "footer"`};
`;

// Navbar wrapper for FrameInspector grid layout
export const NavbarWrapper = styled.div`
	grid-area: navbar;
`;

export const ToolButtonSpacer = styled.div`
	width: 8px;
`;

interface SelectButtonProps {
	active?: boolean;
	disabled?: boolean;
}

export const SelectButton = styled.button<SelectButtonProps>`
	background: ${({ theme, active }) => (active ? theme.gray[200] : 'transparent')};
	border: 1px solid ${({ theme, active }) => (active ? theme.gray[400] : theme.gray[400])};
	border-radius: 4px;
	display: flex;
	align-items: center;
	justify-content: center;
	color: ${({ theme }) => theme.gray[1000]};
	gap: 4px;
	padding-top: 7px;
	padding-bottom: 7px;
	padding-left: 8px;
	padding-right: 12px;
	outline: none; // to prevent outline appearing when we press Esc and this button is focused

	${({ disabled }) =>
		disabled &&
		`
		opacity: 0.5;
		point-events: none;
		cursor: not-allowed;
	`}
`;

export const Share = styled.div`
	margin-left: 8px;
	margin-right: 4px;
`;

// nested buttons are not allowed so we have a separate style for the dropdown trigger
export const DropdownTrigger = styled.div`
	background: transparent;
	border: none;
	border-radius: 4px;
	padding-left: 1px;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 34px;
	height: 40px;

	&:hover {
		background: ${({ theme }) => theme.gray[100]};
	}
`;

export const StatusIndicator = styled.div`
	display: flex;
	justify-content: center;
	align-items: end;
	margin-bottom: 22px;
`;

export const OverlayText = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: calc(100% - 60px);
	max-width: 600px;
	padding-left: 30px;
	padding-right: 30px;
	margin-bottom: 20px;
	font-family: 'JetBrains Mono', sans-serif;
	font-size: 18px;
	font-weight: 600;
	color: ${unthemed.gray[100]};
	text-align: center;
	line-height: 1.7;
	word-break: break-word;
	overflow-wrap: break-word;
`;

export const ContextMenuWrapper = styled.div<{ x: number; y: number; isVisible?: boolean }>`
	position: fixed;
	top: ${(props) => props.y}px;
	left: ${(props) => props.x}px;
	z-index: 10000;
	background: none;
	border: none;
	opacity: ${(props) => (props.isVisible ? 1 : 0)};
	pointer-events: ${(props) => (props.isVisible ? 'auto' : 'none')};
	transition: opacity 0.2s ease-in-out;
	transform: translateY(-100%);
`;

export const ContextMenu = styled.div`
	${BaseContent}
`;

export const Items = styled.div`
	${BaseItem}
	&:hover {
		background: ${({ theme }) => theme.blue[500]};
		outline: none;
	}
`;

export const PrototypeArea = styled.div`
	grid-area: prototype;
	position: relative;
	overflow: hidden;
`;

export const Footer = styled.div`
	grid-area: footer;
	height: ${footerHeight}px;
	background: ${({ theme }) => theme.gray[0]};
	border-top: 1px solid ${({ theme }) => theme.gray[200]};
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0 16px;
	position: relative;
`;

export const FooterActions = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
`;

export const FooterButton = styled.button<{ disabled?: boolean }>`
	background: none;
	border: none;
	display: flex;
	padding-bottom: 4px;
	align-items: center;
	justify-content: center;
	width: 24px;
	height: ${footerHeight}px;
	border-radius: 4px;
	color: ${({ theme, disabled }) => (disabled ? theme.gray[400] : theme.gray[600])};
	cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

	&:hover {
		background: ${({ theme, disabled }) => (disabled ? 'transparent' : theme.gray[100])};
		color: ${({ theme, disabled }) => (disabled ? theme.gray[400] : theme.gray[800])};
	}

	&:disabled {
		opacity: 0.5;
		pointer-events: none;
	}
`;

export const FooterSpacer = styled.div`
	flex: 1;
`;

export const DimensionsDisplay = styled.div`
	position: absolute;
	right: 12px;
	margin-top: -1px;
	top: 50%;
	font-weight: 500;
	transform: translateY(-50%);
	font-family: Inter, sans-serif;
	font-size: 10px;
	color: ${({ theme }) => theme.gray[600]};
	user-select: none;
	white-space: nowrap;
`;
